 <div class="media-selector-container">
  <div class="media-selection-text">{{getString('mediaSelection')}}</div>

  <div *ngFor="let mediaType of mediaTypes" class="media-container" [class.active]="isActive(mediaType)">

    <a *ngIf="!nolinks" class="media-item" [class.media-item-available]="mediaIsAvailable(mediaType)"
      [class.media-item-unavailable]="!mediaIsAvailable(mediaType)" [routerLink]="getLink(mediaType)" (click)="select(mediaType)">
      <span class="material-icons media-icon" [class.media-icon-available]="mediaIsAvailable(mediaType)">{{getMaterialIcon(mediaType)}}</span>
      <span class="media-name" [class.media-name-unavailable]="!mediaIsAvailable(mediaType)">{{getMediaTypeString(mediaType)}}</span>
    </a>

    <span *ngIf="nolinks" class="media-item" [class.media-item-available]="mediaIsAvailable(mediaType)"
      [class.media-item-unavailable]="!mediaIsAvailable(mediaType)" (click)="select(mediaType)">
      <span class="material-icons media-icon" [class.media-icon-available]="mediaIsAvailable(mediaType)">{{getMaterialIcon(mediaType)}}</span>
      <span class="media-name" [class.media-name-unavailable]="!mediaIsAvailable(mediaType)">{{getMediaTypeString(mediaType)}}</span>
    </span>

  </div>

</div>
